import { render, staticRenderFns } from "./SwForm.vue?vue&type=template&id=70255387"
import script from "./SwForm.vue?vue&type=script&lang=js"
export * from "./SwForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports